/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsTempArrowsCornerChekIn: {
  name: 'temp-arrows-corner-chek-in';
  data: string;
} = {
  name: 'temp-arrows-corner-chek-in',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.354 3.354a.5.5 0 0 0-.708-.708L12 5.293l-.646-.647a.5.5 0 0 0-.708.708l1 1a.5.5 0 0 0 .708 0l3-3Zm-11 2a.5.5 0 1 0-.708-.708l-3 3a.5.5 0 0 0 0 .708l3 3a.5.5 0 0 0 .708-.708L2.207 8.5H10a.5.5 0 0 1 .5.5v4a.5.5 0 0 0 1 0V9A1.5 1.5 0 0 0 10 7.5H2.207l2.147-2.146Z" fill="currentColor"/></svg>`,
};
